module.exports = __webpack_public_path__ + "static/media/BannerFLogo.3d039c8d.png";